import React, { useState } from 'react';
import { arrayOf, element, func, number, oneOfType, shape, string } from 'prop-types';
import theme from 'resources/themes';
import { IconArrowUp } from 'assets/icons';

function DropdownComponent({ label, options, position = { top: 52, right: -6 } }) {
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  function onDropdownClick() {
    setUserMenuOpen((prev) => !prev);
  }

  function onItemClick(onClick) {
    setUserMenuOpen(false);
    onClick && onClick();
  }

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={onDropdownClick}
        style={{
          alignItems: 'center',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          padding: 0,
          outline: 'none',
        }}
      >
        {label}
      </button>
      {userMenuOpen && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            background: 'white',
            border: `1px solid ${theme.color.lightGrayishBlue2}`,
            borderRadius: 5,
            minWidth: 300,
            padding: 0,
            position: 'absolute',
            width: '100%',
            top: position.top,
            right: position.right,
            bottom: position.bottom,
            left: position.left,
            zIndex: 9999,
          }}
        >
          {options.map((option, index) => (
            <button
              key={`option-${index}`}
              onClick={() => onItemClick(option.onClick)}
              style={{
                cursor: 'pointer',
                background: 'transparent',
                border: 'none',
                fontSize: 16,
                outline: 'none',
                padding: '10px 10px',
                borderBottom:
                  index < options.length - 1
                    ? `1px solid ${theme.color.paleBlue}`
                    : 'none',
                position: 'relative',
              }}
            >
              {option.label}
              {index === 0 && (
                <div style={{ position: 'absolute', top: -19, right: 15 }}>
                  <IconArrowUp />
                </div>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

DropdownComponent.propTypes = {
  label: oneOfType([string, element]),
  options: arrayOf(
    shape({
      label: oneOfType([string, arrayOf(element)]),
      onClick: func,
    })
  ),
  position: shape({
    top: number,
    right: number,
    bottom: number,
    left: number,
  }),
};

export default DropdownComponent;
